import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'
import 'semantic-ui-css/components/form.min.css'
import 'semantic-ui-checkbox/checkbox.min'
import 'semantic-ui-css/components/checkbox.min.css'
import 'semantic-ui-css/components/checkbox.css'
import '../../entrypoints/modules/semantic-ui-dropdown'
import modal from 'bootstrap/js/dist/modal'
import {
  AT_LEAST_TWO_OPTIONS,
  MAXIMUM_OPTIONS_REACHED,
  trans,
  UPLOAD_LOGO,
  PLEASE_ENTER_A_NAME,
  NAME_REQUIRED,
  FIELD_NAME_ALREADY_EXISTS,
  FIELD_TYPE_IS_REQUIRED,
  OPTION_VALUE_REQUIRED,
  OPTION_VALUE_UNIQUE,
  PLEASE_ENTER_MENU_LABEL
} from '../../translator'
import { nl2br } from '../../utils/utils'

$.fn.form = require('semantic-ui-form')
$.fn.checkbox = require('semantic-ui-checkbox')

export default class extends Controller {
  isLeadField = 0

  static targets = [
    'fields',
    'field',
    'addButton',
    'modal',
    'nameInput',
    'typeSelect',
    'error',
    'optionsContainer',
    'optionsList',
    'descriptionContainer',
    'isOptional',
    'typeSelectContainer'
  ]

  static values = {
    prototype: String,
    placeholder: String
  }

  logoChangeHandler = null
  removeImageHandler = null
  btnRavenLightHandler = null
  modalHiddenHandler = null

  nameExists (name, excludeName = null) {
    const inputs = this.fieldsTarget.querySelectorAll('[name$="[name]"]')
    return Array.from(inputs).some(i => {
      const val = (i.value || '').trim()
      if (excludeName && val === excludeName) {
        return false
      }
      return val === name
    })
  }

  connect () {
    // if editingField is set, we are in edit mode, else add mode
    this.editingField = null
    this.index = this.itemsCountValue = this.fieldTargets.length
    this.toggleOptionsContainer()

    const selfReference = this

    $.fn.form.settings.rules.unique = function (fieldLabel, excludeName = undefined) {
      return !selfReference.nameExists(fieldLabel, excludeName)
    }

    $.fn.form.settings.rules.uniqueOptionValue = function (fieldValue) {
      const optionValueNames = []
      $('.field-option:visible').each(function () {
        optionValueNames.push($(this).val())
      })
      return $.grep(optionValueNames, function (optionValueName) {
        return optionValueName.toLowerCase().trim() === fieldValue.toLowerCase().trim()
      }).length === 1
    }

    $('#form-template-save').form({
      fields: {
        name: {
          identifier: 'form_template_name',
          rules: [
            {
              type: 'empty',
              prompt: trans(PLEASE_ENTER_A_NAME, {}, 'form-templates')
            }
          ]
        },
        menu_label: {
          identifier: 'form_template_menuLabel',
          rules: [
            {
              type: 'empty',
              prompt: trans(PLEASE_ENTER_MENU_LABEL, {}, 'validators')
            }
          ]
        }
      },
      inline: true
    })

    this.logoChangeHandler = (event) => {
      const isRemoveLogo = document.getElementById('edit_account_isRemoveLogo')
      if (isRemoveLogo) {
        isRemoveLogo.checked = false
      }

      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = function (e) {
          document.getElementById('previewImage').src = e.target.result
          document.getElementById('logoContainer').classList.remove('d-none')
        }
        reader.readAsDataURL(file)
      }
    }

    this.removeImageHandler = () => {
      document.getElementById('form_template_logoImage').value = ''
      document.getElementsByClassName('custom-file-label')[0].textContent = trans(UPLOAD_LOGO, {}, 'accounts')
      document.getElementById('logoContainer').classList.add('d-none')

      const isRemoveLogo = document.getElementById('form_template_isRemoveLogo')
      if (isRemoveLogo) {
        isRemoveLogo.checked = true
      }
    }

    this.btnRavenLightHandler = () => {
      const $form = $('#form-template-save')
      $form.form('validate form')
      if ($form.form('is valid')) {
        document.getElementById('form-template-save').submit()
      }
    }

    this.modalHiddenHandler = () => {
      this.clearModal()
    }

    document.getElementById('form_template_logoImage').addEventListener('change', this.logoChangeHandler)
    document.getElementById('removeImage').addEventListener('click', this.removeImageHandler)
    document.querySelectorAll('.btn-raven-light').forEach(btn => {
      btn.addEventListener('click', this.btnRavenLightHandler)
    })
    $(this.modalTarget).on('hidden.bs.modal', this.modalHiddenHandler)
  }

  disconnect () {
    document.getElementById('form_template_logoImage')?.removeEventListener('change', this.logoChangeHandler)
    document.getElementById('removeImage')?.removeEventListener('click', this.removeImageHandler)
    document.querySelectorAll('.btn-raven-light').forEach(btn => {
      btn.removeEventListener('click', this.btnRavenLightHandler)
    })
    $(this.modalTarget).off('hidden.bs.modal', this.modalHiddenHandler)
  }

  toggleOptionsContainer () {
    const value = this.typeSelectTarget.value
    if (value === 'checkbox' || value === 'dropdown') {
      this.optionsContainerTarget.style.display = ''

      if ($('.option-row input[type="text"]').length === 0) {
        this.addOption()
        this.addOption()
      }
    } else {
      this.optionsContainerTarget.style.display = 'none'
    }

    if (value === 'static-text') {
      this.descriptionContainerTarget.style.display = ''
      this.isOptionalTarget.style.display = 'none'
    } else {
      this.isOptionalTarget.style.display = ''
      this.descriptionContainerTarget.style.display = 'none'
    }

    if (value === 'short-text' && this.isLeadField) {
      this.isOptionalTarget.style.display = 'none'
      this.descriptionContainerTarget.style.display = 'none'
      this.typeSelectContainerTarget.style.display = 'none'
    } else {
      this.typeSelectContainerTarget.style.display = ''
    }

    const currentName = this.editingField ? this.editingField.querySelector('[name$="[name]"]').value : null

    const fields = {
      name: {
        identifier: 'field-name',
        rules: [
          { type: 'empty', prompt: trans(NAME_REQUIRED, {}, 'form-templates') },
          { type: `unique[${currentName}]`, prompt: trans(FIELD_NAME_ALREADY_EXISTS, {}, 'validators') }
        ]
      }
    }

    if (!this.isLeadField) {
      fields.type = {
        identifier: 'field-type',
        rules: [
          { type: 'empty', prompt: trans(FIELD_TYPE_IS_REQUIRED, {}, 'validators') }
        ]
      }
    }

    if (['dropdown', 'checkbox'].includes(this.typeSelectTarget.value)) {
      $('.option-row input[type="text"]:visible').each(function () {
        fields[this.id] = {
          identifier: this.id,
          rules: [
            {
              type: 'empty',
              prompt: trans(OPTION_VALUE_REQUIRED, {}, 'validators')
            },
            {
              type: 'uniqueOptionValue',
              prompt: trans(OPTION_VALUE_UNIQUE, {}, 'validators')
            }
          ]
        }
      })
    }

    $('#field-save-form').form({
      fields,
      inline: true
    })

    $('.ui.dropdown').dropdown()
  }

  addOption (event = undefined, editedOption = null) {
    event?.preventDefault()

    $('.general-field-option-errors:visible').text('')

    const maxCountFieldOptionConstraint = $('input[name=field_type]').val() === 'dropdown' ? 100 : 10

    const visibleOptions = $('.option-row:visible').length
    if (visibleOptions >= maxCountFieldOptionConstraint) {
      $('.general-field-option-errors:visible').text(trans(MAXIMUM_OPTIONS_REACHED, {}, 'validators'))
      return false
    }

    const tpl = document.getElementById('option-template')
    const clone = tpl.content.firstElementChild.cloneNode(true)

    // Assign a unique name for Semantic UI validation
    const input = clone.querySelector('input[type="text"]')
    if (input) {
      const index = editedOption ? editedOption.position - 1 : visibleOptions

      if (editedOption) {
        input.value = editedOption.optionValue
      }

      input.name = `option-${index}`
      input.id = `option-${index}` // Add unique id
      input.classList.add('field-option')
    }

    this.optionsListTarget.insertBefore(clone, this.addOptionBtnTarget)
  }

  removeOption (event) {
    event.preventDefault()

    if ($(('.option-row:visible')).length <= 2) {
      $('.general-field-option-errors:visible').text(trans(AT_LEAST_TWO_OPTIONS, {}, 'validators'))
      return false
    }

    event.target.closest('.option-row').remove()
  }

  addItem () {
    this.isLeadField = 0
    this.editingField = null
    this.nameInputTarget.value = ''
    this.typeSelectTarget.value = 'short-text'
    this.index = this.fieldTargets.length

    const rows = this.optionsListTarget.querySelectorAll('.option-row')
    rows.forEach(row => row.remove())

    this.toggleOptionsContainer()

    $(this.modalTarget).modal('show')
  }

  editItem (event) {
    const container = event.currentTarget.closest('.form-field-container')
    const proto = container.querySelector('.form-field-proto-container')

    this.editingField = container

    const data = this.readProto(proto)

    this.nameInputTarget.value = data.name || ''
    this.typeSelectTarget.value = data.type || ''
    const descriptionTextarea = this.descriptionContainerTarget.querySelector('textarea')
    if (descriptionTextarea) {
      descriptionTextarea.value = data.description || ''
    }
    this.optionsListTarget.value = data.fieldOptions || ''
    this.index = data.position - 1
    this.isOptionalTarget.value = data.isOptional

    this.isLeadField = data.isLeadField === '1'

    // Set the Semantic UI checkbox state
    $(this.isOptionalTarget)
      .checkbox(data.isOptional === '1' ? 'check' : 'uncheck')

    if (data.fieldOptions && Array.isArray(data.fieldOptions)) {
      data.fieldOptions.forEach((optionData) => {
        this.addOption(undefined, optionData)
      })
    }

    this.toggleOptionsContainer()

    $(this.modalTarget).modal('show')
  }

  readProto (protoEl) {
    const obj = {}
    obj.fieldOptions = []

    protoEl.querySelectorAll('input[type="hidden"]').forEach(input => {
      const optionMatch = input.name.match(
        /\[fieldOptions]\[(\d+)]\[(\w+)]/
      )
      if (optionMatch) {
        const idx = parseInt(optionMatch[1], 10)
        const key = optionMatch[2]
        if (!obj.fieldOptions[idx]) obj.fieldOptions[idx] = {}
        obj.fieldOptions[idx][key] = input.value
      } else {
        const match = input.name.match(/\[([^\]]+)]$/)
        if (match) {
          const key = match[1]
          if (!['optionValue'].includes(key)) {
            obj[key] = input.value
          }
        }
      }
    })

    obj.fieldOptions = obj.fieldOptions.filter(Boolean)
    return obj
  }

  closeModal () {
    $(this.modalTarget).modal('hide')
  }

  clearModal () {
    this.isLeadField = false
    if (this.hasNameInputTarget) this.nameInputTarget.value = ''
    if (this.hasTypeSelectTarget) this.typeSelectTarget.value = 'short-text'
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ''
      this.errorTarget.style.display = 'none'
    }

    const descriptionTextarea = this.descriptionContainerTarget.querySelector('textarea')
    if (descriptionTextarea) {
      descriptionTextarea.value = ''
    }

    const rows = this.optionsListTarget.querySelectorAll('.option-row')
    rows.forEach((row) => {
      row.remove()
    })
    this.optionsContainerTarget.style.display = 'none'

    // Set the Semantic UI checkbox state
    $(this.isOptionalTarget).checkbox('uncheck')

    $('.general-field-option-errors').text('')
    $('#field-save-form').form('clear')
  }

  confirmSave () {
    this.toggleOptionsContainer()

    if (!$('#field-save-form').form('is valid')) {
      $('#field-save-form').form('validate form')
      return
    }

    const name = (this.nameInputTarget?.value || '')
    const type = this.typeSelectTarget?.value || 'short-text'

    const staticTextArea = this.descriptionContainerTarget.querySelector('textarea')
    const staticText = staticTextArea.value

    const tpl = document.getElementById('field-template')
    const clone = tpl.content.firstElementChild.cloneNode(true)

    const protoParent = clone.querySelector('.form-field-proto-container')

    const html = this.prototypeValue.replace(new RegExp(this.placeholderValue, 'g'), String(this.index))
    const frag = document.createRange().createContextualFragment(html)
    protoParent.append(...frag.childNodes)

    const typeInput = protoParent.querySelector('[name$="[type]"]')
    if (typeInput) typeInput.value = type

    const nameInput = protoParent.querySelector('[name$="[name]"]')
    if (nameInput) nameInput.value = name

    const descriptionInput = protoParent.querySelector('[name$="[description]"]')
    if (descriptionInput) descriptionInput.value = staticText

    const isOptionalInput = protoParent.querySelector('[name$="[isOptional]"]')
    if (isOptionalInput) {
      const isOptionalToggle = document.getElementById('isOptionalToggle')
      isOptionalInput.value = isOptionalToggle && isOptionalToggle.checked ? '1' : '0'
    }

    const isLeadFieldInput = protoParent.querySelector('[name$="[isLeadField]"]')
    if (isLeadFieldInput) {
      isLeadFieldInput.value = this.isLeadField ? '1' : '0'
    }

    const posInput = protoParent.querySelector('[name$="[position]"]')
    if (posInput) posInput.value = this.index + 1

    if (type === 'checkbox' || type === 'dropdown') {
      const optionsProtoContainer = protoParent.querySelector(
        '.fieldOptions[data-prototype]'
      )
      const optionPrototypeValue = optionsProtoContainer ? optionsProtoContainer.getAttribute('data-prototype') : null

      if (optionPrototypeValue) {
        const optionInputs = this.optionsListTarget.querySelectorAll('.option-row input[type="text"]')
        optionInputs.forEach((input, optIdx) => {
          const optionHtml = optionPrototypeValue.replace(
            /ptOption/g,
            String(optIdx)
          )
          const optionFrag = document.createRange().createContextualFragment(optionHtml)

          const optionNameInput = optionFrag.querySelector('[name$="[optionValue]"]')
          if (optionNameInput) optionNameInput.value = input.value

          const optionPosInput = optionFrag.querySelector('[name$="[position]"]')
          if (optionPosInput) optionPosInput.value = optIdx + 1

          optionsProtoContainer.append(...optionFrag.childNodes)
        })
      }
    }

    // field list template management

    const root = clone.querySelector('.form-field-template-container')
    const tplRoot = root.querySelector('.form-field-template')
    const fieldTpl = document.getElementById(`field-template-${type}`)

    const fieldTplClone = fieldTpl.content.firstElementChild.cloneNode(true)

    if (this.isLeadField) {
      const removeFieldBtn = root.querySelector('.remove-field')
      if (removeFieldBtn) {
        removeFieldBtn.remove()
      }
    }

    const label = root.querySelector('.form-label')
    if (label) {
      label.textContent = name
      const isOptionalToggle = document.getElementById('isOptionalToggle')
      if (!isOptionalToggle || !isOptionalToggle.checked) {
        if (this.typeSelectTarget.value !== 'static-text') {
          label.innerHTML += ' <span class="text-danger">*</span>'
        }
      }
    }

    const leadFieldFlag = root.querySelector('.lead-field-flag')

    if (leadFieldFlag) {
      leadFieldFlag.textContent = this.isLeadField ? '(Lead Field)' : ''
    }

    if (!fieldTpl || !tplRoot) throw new Error('Template not found for type: ' + type)
    tplRoot.appendChild(fieldTplClone)

    if (type === 'static-text' && fieldTplClone) {
      fieldTplClone.innerHTML = nl2br(staticText)
    }

    if ((type === 'dropdown') && fieldTplClone) {
      const optionsList = fieldTplClone.querySelector('.dropdown-options-list')
      if (optionsList) optionsList.innerHTML = ''

      const optionInputs = this.optionsListTarget.querySelectorAll('.option-row input[type="text"]')
      optionInputs.forEach((input) => {
        if (optionsList) {
          const visibleItem = document.createElement('div')
          visibleItem.className = 'px-3 py-1'
          visibleItem.textContent = input.value
          optionsList.appendChild(visibleItem)
        }
      })
    }

    if (type === 'checkbox' && fieldTplClone) {
      const container = fieldTplClone

      container.innerHTML = ''
      const optionInputs = this.optionsListTarget.querySelectorAll('.option-row input[type="text"]')

      optionInputs.forEach((input) => {
        const field = document.createElement('div')
        field.className = 'field'

        field.innerHTML = `
      <div class="ui disabled checkbox">
        <input type="checkbox" class="hidden" disabled />
        <label></label>
      </div>
    `
        field.querySelector('label').textContent = input.value
        container.appendChild(field)
      })
    }

    if (this.editingField) {
      this.editingField.replaceWith(clone)
      this.reindexPositions()
    } else {
      this.fieldsTarget.appendChild(clone)
      this.index++
      this.itemsCountValue++
      this.reindexPositions()
    }

    this.closeModal()
  }

  removeItem (event) {
    this.fieldTargets.forEach((element) => {
      if (element.contains(event.target)) {
        element.remove()
        this.itemsCountValue--
      }
    })

    this.reindexPositions()
  }

  reindexPositions () {
    const items = this.fieldsTarget.querySelectorAll(
      '[data-save-form-template-target]'
    )
    items.forEach((el, i) => {
      const pos = el.querySelector('[name$="[position]"]')
      if (pos) pos.value = i + 1
    })
  }
}
